export default __webpack_public_path__ + "static/blogs-img-3-497e73c1bb636eb30ae008387d276041.png";